import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { GroupPricesGetInternationalGroupPrice$Params } from 'src/app/core/api/fn/group-prices/group-prices-get-international-group-price';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { GroupPricesService } from '../../../../core/api/services';
import { EventTypes } from '../../../../core/constants/event-types';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
  selector: 'app-international-group-price',
  templateUrl: './international-group-price.component.html',
  styles: [``],
  imports: [BaseFormModule],
})
export class InternationalGroupPriceComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: GroupPricesGetInternationalGroupPrice$Params = {};
  pricePerPart: number;
  //#endregion

  constructor(protected currentService: GroupPricesService) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.loading = false;
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      smsCp: new FormControl(''),
      region: new FormControl(''),
    });
  }

  //#endregion

  //#region groupPriceDetail model
  getInternationalGroupPrice() {
    this.loading = true;
    this.currentService
      .groupPricesGetInternationalGroupPrice(this.model)
      .pipe(this.basePipeOperators())
      .subscribe((item) => {
        if (item.isSucceed) this.pricePerPart = item?.data.pricePerPart;
      });
  }
  //#endregion

  //#region operation

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    try {
      this.getInternationalGroupPrice();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion
}
